<ng-container *mdAutorun>
  <h2 data-test="OdugJx0k" style="margin-bottom: 15px">Activity log</h2>
  <table data-test="dwlzlErT" class="items-table" style="margin-bottom: 10px">
    <thead data-test="TGmBjfIh">
      <tr data-test="2AJO1_Gd">
        <th data-test="LTBQ_3g3">Date</th>
        <th data-test="-9Ad7mSy">Time</th>
        <th data-test="3sHjknln">User</th>
        <ng-container *ngIf="dataColumns?.length">
          <th data-test="BvV_UGbG" *ngFor="let dataColumn of dataColumns">
            {{ dataColumn.title }}
          </th>
        </ng-container>
        <th data-test="CGrYZsxS">Action</th>
        <th *ngIf="snapshotLinkTemplate" data-test="on9GwVC6"></th>
      </tr>
    </thead>

    <tr data-test="SsT0Vkg8" *ngFor="let event of events">
      <td data-test="WLVqwu4X">{{ event.createdAt | formatDate }}</td>
      <td data-test="FbPrL1ad">{{ event.createdAt | time }}</td>
      <td data-test="v61hYeUq">{{ event.user?.firstName }} {{ event.user?.lastName }}</td>
      <ng-container *ngIf="dataColumns?.length">
        <ng-container *ngFor="let dataColumn of dataColumns">
          <td data-test="SwusWQGh">
            <ng-container *ngIf="getDataField(event, dataColumn.dataKey) as dataValue">
              <ng-container [ngSwitch]="dataColumn.dataType">
                <ng-container *ngSwitchCase="'currency'">
                  <span data-test="bqrxKkQe" *ngIf="currencySign">
                    {{ currencySign }}
                  </span>
                  {{ $any(dataValue) | fromCents | companyCurrency }}
                </ng-container>
                <ng-container *ngSwitchCase="'changes'">
                  <div
                    data-test="q-xgdnHc"
                    *ngFor="let line of formatChangesData(toJS(dataValue))"
                  >
                    {{ line }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'link'">
                  <a
                    data-test="ZKhJuZgg"
                    *ngIf="getDataLink(event, dataColumn) as link; else noLink"
                    href="{{ link }}"
                  >
                    {{ dataValue }}
                  </a>
                  <ng-template #noLink>
                    {{ dataValue }}
                  </ng-template>
                </ng-container>
                <ng-container *ngSwitchDefault>{{ dataValue }</ng-container>
              </ng-container>
            </ng-container>
          </td>
        </ng-container>
      </ng-container>
      <td data-test="uyFSGaCa">{{ actionFormat(event.action) }}</td>
      <td data-test="8MwRIFXh" *ngIf="showCommentColumn">
        <a
          data-test="TXw_JULl"
          *ngIf="getSnapshotLink(event) as link"
          class="link mr-2"
          [routerLink]="[link]"
        >
          Snapshot
        </a>
        <span data-test="vyvCJZLT">{{ event.comment }}</span>
      </td>
    </tr>
  </table>
  <md-paginator
    data-test="sbotfGk1"
    (newPage)="loadPage($event)"
    [currentPage]="currentPage"
    [pageCount]="pageCount"
    style="margin-bottom: 39px; display: inline-block"
  ></md-paginator>
</ng-container>
